<form  [formGroup] = "customerForm">
  <h1 *ngIf ="mode ==1" mat-dialog-title style="padding-right: 20px"> {{data.customer_name}}  <mat-slide-toggle [checked]=!data.inactivecustomer (change)=inactiveToggle()  >Status: {{getStatusText()}}</mat-slide-toggle></h1>

  <h1 *ngIf="mode == 2" mat-dialog-title>
  Add Customer
  <div class="header-checkboxes">
    <span><mat-label>Create 'Re-' Job?</mat-label>
    <mat-checkbox formControlName="welcome" style="margin-left: 5px;"></mat-checkbox></span>
    <span><mat-label>Modeling Customer?</mat-label>
    <mat-checkbox formControlName="modeling" style="margin-left: 5px;"></mat-checkbox></span>
  </div>
</h1>

  <mat-tab-group>

<mat-tab label = "Basic" dynamicHeight = false style="color:black;">
  <div mat-dialog-content style="width:95%">

    <mat-form-field style="width:95%">
      <mat-label>Referral: {{data.creferral}}</mat-label>
      <input  #refname matInput formControlName = "creferral" [matAutocomplete] = "custauto">
  </mat-form-field>

<!-- we need to not show the autocomplete when not in use-->
<mat-autocomplete #custauto = "matAutocomplete" (optionSelected) = "onSelectContact($event.option.value)" [displayWith]="displayFunction">
  <mat-option *ngFor="let contact of (contact$ | async)" [value]="contact">
    <span>{{ contact.name}}</span>
  </mat-option>
</mat-autocomplete>

    <mat-form-field style="width:95%">
      <mat-label>Customer Name: </mat-label>
      <input matInput formControlName="customer_name">
    </mat-form-field>

    <mat-form-field style="width:95%">
      <mat-label>Registry Name: </mat-label>
      <input matInput formControlName="registry_name">
    </mat-form-field>

    <mat-form-field style="width:95%">
      <mat-label>Office Street Address: </mat-label>
      <input matInput formControlName="office_street_address">
    </mat-form-field>

    <mat-form-field style="width:95%">
      <mat-label>City: </mat-label>
      <input matInput formControlName="office_city">
    </mat-form-field>

    <mat-form-field style="width:95%">
      <mat-label>State: </mat-label>
      <input matInput formControlName="office_state">
    </mat-form-field>

    <mat-form-field style="width:95%">
      <mat-label>Office Zip: </mat-label>
      <input matInput formControlName="office_zip">
    </mat-form-field>



    <br>
      </div>

</mat-tab>

<mat-tab label = "Details" style="color:black;">

  <div class="radio-box">
    <mat-label>Customer Type: </mat-label>
    <mat-radio-group formControlName="customer_type" aria-label="Select an option">
      <mat-radio-button style="padding-right: 2%" value="Builder">Builder</mat-radio-button>
      <mat-radio-button style="padding-right: 2%" value="HVAC Contractor">Hvac Contractor</mat-radio-button>
      <mat-radio-button style="padding-right: 2%" value="Other">Other</mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="radio-box">
    <mat-label>Customer Tier: </mat-label>
    <mat-radio-group formControlName="tier" aria-label="Select an option">
      <mat-radio-button style="padding-right: 2%" value="Success">Success</mat-radio-button>
      <mat-radio-button style="padding-right: 2%" value="Essentials">Essentials</mat-radio-button>
      <mat-radio-button style="padding-right: 2%" value="Maintenance">Maintenance</mat-radio-button>
      <mat-radio-button style="padding-right: 2%" value="House">House</mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="radio-box">
    <mat-label>Billing Type: </mat-label>
    <mat-radio-group formControlName="billing_type" aria-label="Select an option">
      <mat-radio-button style="padding-right: 2%" value="PO System">PO System</mat-radio-button>
      <mat-radio-button style="padding-right: 2%" value="Invoice">Invoice</mat-radio-button>
      <mat-radio-button style="padding-right: 2%" value="PO System - EPO Invoice">PO System - EPO Invoice</mat-radio-button>
    </mat-radio-group>
  </div>

  <mat-form-field style="width:95%">
    <mat-label>Planroom Website: </mat-label>
    <input matInput formControlName="planroom_web_address">
  </mat-form-field>

  <mat-form-field style="width:95%">
    <mat-label>Planroom Login: </mat-label>
    <input matInput formControlName="planroom_username_login">
  </mat-form-field>

  <div class="radio-box">
    <mat-label>Plans Pathway: </mat-label>
    <mat-radio-group formControlName = "planpath" aria-label="Select an option">
      <mat-radio-button style="padding-right: 2%" value="Plans Intake">Plans Intake</mat-radio-button>
      <mat-radio-button style="padding-right: 2%"  value="Master Plans">Master Plans</mat-radio-button>
      <mat-radio-button style="padding-right: 2%" value="Custom">Custom</mat-radio-button>
      <mat-radio-button style="padding-right: 2%" value="NA">N/A</mat-radio-button>
    </mat-radio-group>
  </div>


  <div class="dropdown-row">
    <mat-form-field style="width:95%">
      <mat-label> Invoice Delivery Method</mat-label>
      <mat-select  formControlName = "inv_delivery_mtd">
        <mat-option value = "Approve in PO System"> Approve in PO System </mat-option>
        <mat-option value = "Auto-Pay"> Auto-Pay </mat-option>
        <mat-option value = "Auto-Pay/Email Invoices"> Auto-Pay/Email Invoices </mat-option>
        <mat-option value = "Auto-Pay - Approve EPOs in PO System"> Auto-Pay - Approve EPOs in PO System </mat-option>
        <mat-option value = "Email Invoices"> Email Invoices </mat-option>
        <mat-option value = "Auto-Pay/Email Invoices"> Auto-Pay/Email Invoices </mat-option>
        <mat-option value = "Email Signed POs"> Email Signed POs </mat-option>
        <mat-option value = "Mail Invoices"> Mail Invoices </mat-option>
      </mat-select>
    </mat-form-field>
    </div>


    <div class="dropdown-row">
      <mat-form-field style="width:95%">
        <mat-label> Payment Reconciliation Method</mat-label>
        <mat-select  formControlName = "pmt_recon_mtd">
          <mat-option value = "ACH - Email Report"> ACH - Email Report </mat-option>
          <mat-option value = "ACH - Paymode X"> ACH - Paymode X </mat-option>
          <mat-option value = "ACH - PO System"> ACH - PO System </mat-option>
          <mat-option value = "CC Payment - Email Card Info"> CC Payment - Email Card Info </mat-option>
          <mat-option value = "CC Payment - Email Report"> CC Payment - Email Report </mat-option>
          <mat-option value = "Physical Check"> Physical Check </mat-option>
          <mat-option value = "Physical Check - PO System"> Physical Check - PO System </mat-option>
        </mat-select>
      </mat-form-field>
      </div>


      <div class="dropdown-row">
        <mat-form-field style="width:95%">
          <mat-label> PO System </mat-label>
          <mat-select  formControlName = "po_system">
            <mat-option value = "Builder Portal"> Builder Portal </mat-option>
            <mat-option value = "BuilderTrend"> BuilderTrend </mat-option>
            <mat-option value = "ECI Mark Systems"> ECI Mark Systems </mat-option>
            <mat-option value = "Managing it Right"> Managing it Right </mat-option>
            <mat-option value = "SupplyPro"> SupplyPro </mat-option>
            <mat-option value = "TradeTopia"> TradeTopia </mat-option>
            <mat-option value = "VendorSuite"> VendorSuite </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-form-field style="width:95%">
        <mat-label>Accounting Rep: {{accountRep}} </mat-label>
        <input   matInput formControlName = "accounting_rep" [matAutocomplete] = "actrepauto">
      </mat-form-field>

    <mat-autocomplete #actrepauto = "matAutocomplete" (optionSelected) = "onSelectAccountRep($event.option.value)" [displayWith]="displayFunctionEmp">
        <mat-option *ngFor="let em of (employee$ | async)" [value]="em">
          <span>{{ em.employee_name}}</span>
        </mat-option>
      </mat-autocomplete>


      <mat-form-field style="width:95%">
        <mat-label>Account Manager: {{accountManager}} </mat-label>
        <input  matInput formControlName = "account_manager" [matAutocomplete] = "actmanauto">
      </mat-form-field>

    <mat-autocomplete #actmanauto = "matAutocomplete" (optionSelected) = "onSelectAccountManager($event.option.value)" [displayWith]="displayFunctionEmp">
        <mat-option *ngFor="let em of (manager$ | async)" [value]="em">
          <span>{{ em.employee_name}}</span>
        </mat-option>
      </mat-autocomplete>


      <mat-form-field style="width:95%">
        <mat-label>HERS Modeler: {{hersModeler}} </mat-label>
        <input  matInput formControlName = "hers_modeler" [matAutocomplete] = "acthersauto">
      </mat-form-field>

      <mat-form-field style="width:95%">
        <mat-label>Reviewer(s) Emails : </mat-label>
        <textarea matInput formControlName = "reviewer" rows="3" placeholder="reviewer1@builder.com, reviewer2@builder.com"></textarea>
        <mat-hint>Separate multiple emails with commas (or one per line)</mat-hint>
      </mat-form-field>
      

    <mat-autocomplete #acthersauto = "matAutocomplete" (optionSelected) = "onSelectHersModeler($event.option.value)" [displayWith]="displayFunctionEmp">
        <mat-option *ngFor="let em of (hersModeler$ | async)" [value]="em">
          <span>{{ em.employee_name}}</span>
        </mat-option>
      </mat-autocomplete>









  <mat-form-field style="width:95%">
    <mat-label>Certificate Manager: </mat-label>
    <input matInput formControlName="certificates_go_to">
  </mat-form-field>

  <mat-form-field style="width:95%">
    <mat-label>License #: </mat-label>
    <input matInput formControlName="licenseno">
  </mat-form-field>

  <mat-form-field style="width:95%">
    <mat-label>Customer Code Compliance: </mat-label>
    <input matInput formControlName="codecomp">
  </mat-form-field>

  <mat-form-field style="width:95%">
    <mat-label>Hvac Designer Email Address: </mat-label>
    <input matInput formControlName="designeremail">
  </mat-form-field>

  <mat-form-field style="width:95%">
    <mat-label>Custom URL: </mat-label>
    <input matInput formControlName="customurl">
  </mat-form-field>

  <mat-form-field style="width:95%">
    <mat-label>Document URL: </mat-label>
    <input matInput formControlName="doc_url">
  </mat-form-field>

  <mat-form-field style="width:95%">
    <mat-label>Starts Coordinator: </mat-label>
    <input matInput formControlName="startscoord">
  </mat-form-field>

  <mat-form-field style="width:95%">
    <mat-label>Billing Contact: </mat-label>
    <input matInput formControlName="billcontact">
  </mat-form-field>

  <mat-form-field style="width:95%">
    <mat-label>Send For Review Contact(s): </mat-label>
    <textarea matInput formControlName="sendrevcon"></textarea>
  </mat-form-field>

  <mat-form-field style="width:95%">
    <mat-label>Purchasing: </mat-label>
    <input matInput formControlName="purchasing">
  </mat-form-field>

</mat-tab>

<mat-tab label = "Notes" style="color:black;" >
  <div mat-dialog-content style="width:95%">
    <mat-form-field style="width:95%">
      <mat-label>Billing Notes: </mat-label>
      <textarea matInput formControlName = "billing_notes" rows="4"></textarea>
    </mat-form-field>

    <mat-form-field style="width:95%">
      <mat-label>Customer Notes: </mat-label>
      <textarea matInput formControlName = "customer_note" rows="4"></textarea>
    </mat-form-field>

  </div>
</mat-tab>

<mat-tab label = "Flags" style="color:black;" >
  <div mat-dialog-content style="width:95%">
    <h3>Check the items below that apply</h3>
    <br>
    <div fxLayout="row" fxLayout.xs="column">

    <div class = "formitem-section" style="padding-right: 20px">
      <mat-label>Payment Hold</mat-label>
      <mat-checkbox formControlName = "paymenthold"></mat-checkbox>
    </div>

    <div class = "formitem-section" style="padding-right: 20px">
      <mat-label>Welcome Package Sent?</mat-label>
      <mat-checkbox formControlName = "welcome"></mat-checkbox>
    </div>

    <div class = "formitem-section" style="padding-right: 20px">
      <mat-label>Referral Paid?</mat-label>
      <mat-checkbox formControlName = "refpaid"></mat-checkbox>
    </div>




    </div>

  </div>

</mat-tab>
</mat-tab-group>

  <div class ="" mat-dialog-actions>
    <button mat-button (click)="dialogRef.close()" >Close</button>

    <button *ngIf ="mode ==1" mat-button (click)="save()" [mat-dialog-close]="data" cdkFocusInitial>Save</button>
    <button *ngIf ="mode ==2" mat-button (click)="add()" [mat-dialog-close]="data" cdkFocusInitial>Add </button>

  </div>
  </form>



